import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import arrowIcon from 'assets/svg/red-right-arrow.svg';

import { RedTextButton } from './RedTextButton';

const Button = styled(RedTextButton)`
  margin-left: 0;
  padding: 0;
  white-space: nowrap;

  ${theme.mq.phone} {
    width: auto;
    min-width: 0;
    height: auto;
    font-size: 14px;
    line-height: 16px;
  }
`;

const Icon = styled.img`
  padding-left: 12px;

  ${theme.mq.phone} {
    padding-left: 4px;
    width: 12px;
    height: auto;
  }
`;

interface Props {
  onClick: () => void;
}

export const ShowAllButton = ({ onClick }: Props) => {
  const { t } = useTranslation('common');

  return (
    <Button onClick={onClick} data-testid={'show-all-button'}>
      {t('show-all')} <Icon src={arrowIcon} />
    </Button>
  );
};
